<template>
  <v-card class="mx-auto" :max-width="$vuetify.breakpoint.sm ? '500' : '344'">
    <v-img
      src="https://images.unsplash.com/photo-1526925539332-aa3b66e35444?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=701&q=80"
      height="200px"
    ></v-img>

    <v-card-title>
      <vue-typed-js :strings="['What?']" :typeSpeed="80">
        <span class="typing"></span>
      </vue-typed-js>
    </v-card-title>
    <v-card-text class="text-justify">
      I'm a programmer capable of both front end development and design. I can
      also do full stack development as I have experience working with
      <strong>Node.js</strong>, <strong>Express.js</strong> and
      <strong>MongoDB</strong>. I am fluent in <strong>HTML5</strong>,
      <strong>CSS3</strong> and <strong>ES6 Javascript</strong>. I can work with
      both <strong>React.js</strong> and <strong>Vue.js</strong>. I can also use
      <strong>AdobeXD</strong> and <strong>Figma</strong> for prototyping.
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        text
        class="font-weight-black"
        @click="$store.commit('previousPage')"
        >Previous</v-btn
      >
      <v-btn text class="font-weight-black" @click="$store.commit('nextPage')"
        >Next</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {};
</script>

<style></style>
